<form [formGroup]="templateForm" novalidate (ngSubmit)="onSubmit()">
  <mat-card class="shipping-card">
    <mat-card-header>
      <mat-card-title>Template</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input matInput placeholder="Display name" formControlName="name" />
            <mat-error
              *ngIf="templateForm.controls['name'].hasError('required')"
            >
              Display Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <textarea
              matInput
              placeholder="Body use {link} as a placeholder for the URL"
              formControlName="body"
            ></textarea>
            <mat-error
              *ngIf="templateForm.controls['body'].hasError('required')"
            >
              Body is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input
              matInput
              #url
              maxlength="200"
              placeholder="URL"
              formControlName="url"
            />
            <mat-hint align="end">{{ url.value.length }} / 200</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input
              matInput
              #slug
              maxlength="50"
              placeholder="Short URL code"
              formControlName="slug"
            />
            <mat-hint align="end">{{ slug.value.length }} / 50</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="accent" type="submit">Save</button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="cancel()"
      >
        Cancel
      </button>
    </mat-card-actions>
  </mat-card>
</form>
